export const API_VERSION = '1.0';

const PREFIX = '/api';

export const ENDPOINTS = {
  auth: {
    login: `${PREFIX}/auth/users/login`,
    register: `${PREFIX}/auth/users/register`,
    registerWithGoogle: `${PREFIX}/auth/users/google`,
    registerWithFacebook: `${PREFIX}/auth/users/facebook`,
    registerWithApple: `${PREFIX}/auth/users/apple`,
    refresh: `${PREFIX}/auth/users/refresh`,
    verifyEmail: `${PREFIX}/auth/users/verify-email`,
    forgotPassword: `${PREFIX}/auth/users/forgot-password`,
    resetPassword: `${PREFIX}/auth/users/reset-password`,
    resendVerification: `${PREFIX}/auth/users/resend-verification`,
    logout: `${PREFIX}/auth/users/logout`,
    logoutAll: `${PREFIX}/auth/users/logout-all`,
    intercom: `${PREFIX}/auth/users/intercom-token`,
    acceptPolicies: `${PREFIX}/auth/users/accept-policies`,
  },
  user: {
    me: `${PREFIX}/users/me`,
    pushNotificationsSubscribe: `${PREFIX}/users/me/push-notifications/subscribe`,
    changePassword: `${PREFIX}/users/change-password`,
    withdrawDailyLimit: (userId: string) => `${PREFIX}/users/${userId}/withdraw-limits/daily-limit`,
    withdrawMonthlyLimit: (userId: string) => `${PREFIX}/users/${userId}/withdraw-limits/monthly-limit`,
    paymentMethods: (userId: string) => `${PREFIX}/users/${userId}/payment-methods`,
    verifyPaymentMethod: (userId: string, cardId: string) => `${PREFIX}/users/${userId}/payment-methods/${cardId}/verify`,
    depositLimit: () => `${PREFIX}/users/me/deposit-limits`,
    getActiveDepositLimit: () => `${PREFIX}/users/me/deposit-limits/active`,
    updateDepositLimit: (depositLimitId: string) => `${PREFIX}/users/me/deposit-limits/${depositLimitId}`,
    allowedSendMarketingEmails: `${PREFIX}/users/me/allowed-send-adw-email`,
  },
  bundles: { //  mock
    all: `${PREFIX}/bundles`,
    getById: (id: string) => `${PREFIX}/bundles/${id}`,
    offers: `${PREFIX}/users/me/bundle-offers`,
  },
  fastShop: {
    meFastBundleOffers: `${PREFIX}/users/me/fast-bundle-offers`,
    userFastBundleOffers: (userId: string) => `${PREFIX}/users/${userId}/fast-bundle-offers`,
  },
  transactions: { // mock
    all: `${PREFIX}/payment-transactions`, // Get all payment transactions
    deposit: `${PREFIX}/payment-transactions/deposit`, // Create deposit payment transaction
    getById: (id: string) => `${PREFIX}/payment-transactions/${id}`, // Get payment transaction by ID
  },
  withdraw: {
    create: `${PREFIX}/withdraw-orders`, // Create withdraw payment transaction
    getAll: `${PREFIX}/withdraw-orders`, // Get all withdraw orders
    config: `${PREFIX}/withdraw-orders/config`, // Get withdraw order configuration (e.g. minimum amount)
    confirm: (orderId: string) => `${PREFIX}/withdraw-orders/${orderId}/confirm`, // Confirm withdraw order
  },

  otp: {
    create: `${PREFIX}/otp/generate`, // Create otp
  },
  orders: {
    create: `${PREFIX}/deposit-orders`,
    all: `${PREFIX}/deposit-orders`,
    getById: (id: string) => `${PREFIX}/deposit-orders/${id}`,
  },
  wallet: {
    me: `${PREFIX}/users/me/wallet`,
    details: `${PREFIX}/users/me/wallet/details`,
    transactions: `${PREFIX}/users/me/wallet/transactions`,
    getTransactionById: (id: string) => `${PREFIX}/wallet-transactions/${id}`,
  },
  kyc: {
    start: `${PREFIX}/kyc/start`,
  },
  verifications: {
    list: `${PREFIX}/users/verifications`,
  },
  crypto: {
    supported: `${PREFIX}/crypto/supported`,
  },
  categories: {
    all: `${PREFIX}/categories`,
    byId: (id: string) => `${PREFIX}/categories/${id}`,
    byName: (name: string) => `${PREFIX}/categories/by-name/${name}`,
  },
  games: {
    all: `${PREFIX}/games`,
    byId: (id: string) => `${PREFIX}/games/${id}`,
    launchUrl: `${PREFIX}/game-integrations/launch-url`,
    favorites: `${PREFIX}/users/me/games/favourite`,
    likeGame: (gameId: string) => `${PREFIX}/users/me/games/${gameId}/like`,
    dislikeGame: (gameId: string) => `${PREFIX}/users/me/games/${gameId}/dislike`,
    similarById: (id: string) => `${PREFIX}/games/${id}/similar`,
    roundsWithWins: (gameId: string) => `${PREFIX}/users/me/games/${gameId}/rounds/with-wins`,
    shareRound: (gameId: string, roundId: string) => `${PREFIX}/users/me/games/${gameId}/rounds/${roundId}/share`,
    sharedRound: (token: string) => `${PREFIX}/rounds/shared/${token}`,
    verifyRound: (roundId: string) => `${PREFIX}/users/me/game-rounds/${roundId}/verify`,
  },
  fairPlay: {
    gameLastWin: (userId: string, gameId: string) => `${PREFIX}/users/${userId}/games/${gameId}/rounds/last-win`,
    report: (gameId: string) => `${PREFIX}/users/me/games/${gameId}/report`,
    gameProviderRtp: (providerId: string, gameId: string) => `${PREFIX}/providers/${providerId}/games/${gameId}/rtp`,
    gameUserRtp: (gameId: string) => `${PREFIX}/users/me/games/${gameId}/rtp`,
    gamesWithWins: `${PREFIX}/users/me/games/with-wins`,
  },
  providers: {
    all: `${PREFIX}/providers`,
    byId: (id: string) => `${PREFIX}/providers/${id}`,
  },
  media: {
    upload: `${PREFIX}/media/upload`,
  },
  banners: {
    public: `${PREFIX}/banners/public`,
    usersBanners: `${PREFIX}/users/me/assigned-banners`,
  },
  rewards: {
    claimDailyReward: `${PREFIX}/users/me/rewards/claim`,
    grouped: `${PREFIX}/users/me/rewards/grouped`,
  },
  systemPages: {
    all: `${PREFIX}/system-pages`,
    idOrAlias: (idOrAlias: string) => `${PREFIX}/system-pages/${idOrAlias}`,
  },
  postalCode: {
    post: `${PREFIX}/postal-request-codes/me/code`,
  },
  reviews: {
    byGame: (gameId: string) => `${PREFIX}/games/${gameId}/reviews`,
  },
  authors: {
    list: `${PREFIX}/authors`,
    byId: (id: string) => `${PREFIX}/authors/${id}`,
  },
} as const;
